/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReportParameterType = {
    String: 'String',
    Int: 'Int',
    Decimal: 'Decimal',
    DateTime: 'DateTime',
    Boolean: 'Boolean',
    Guid: 'Guid',
    Date: 'Date'
} as const;
export type ReportParameterType = typeof ReportParameterType[keyof typeof ReportParameterType];


export function instanceOfReportParameterType(value: any): boolean {
    for (const key in ReportParameterType) {
        if (Object.prototype.hasOwnProperty.call(ReportParameterType, key)) {
            if (ReportParameterType[key as keyof typeof ReportParameterType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportParameterTypeFromJSON(json: any): ReportParameterType {
    return ReportParameterTypeFromJSONTyped(json, false);
}

export function ReportParameterTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportParameterType {
    return json as ReportParameterType;
}

export function ReportParameterTypeToJSON(value?: ReportParameterType | null): any {
    return value as any;
}

export function ReportParameterTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ReportParameterType {
    return value as ReportParameterType;
}

